module.exports = __webpack_public_path__ + "img/veneenlaskupaikka_original.12456d71.jpg";